var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 4,
  width: 24,
  height: 17,
  rx: 2,
  fill: "#F5F5F5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3349 14.9605V12.889H12.404C12.8421 12.889 13.2119 12.7422 13.5134 12.4527L13.5857 12.3793C14.1364 11.7799 14.1002 10.846 13.5134 10.2915C13.2199 9.99786 12.818 9.83882 12.404 9.84698H10.6877V14.9605H11.3349ZM11.3349 12.261V10.4749H12.4203C12.6534 10.4749 12.8745 10.5646 13.0394 10.7277C13.3891 11.0703 13.3971 11.6412 13.0595 11.9959C12.8946 12.1713 12.6615 12.2691 12.4203 12.261H11.3349ZM16.6044 11.735C16.327 11.4781 15.9492 11.3476 15.4709 11.3476C14.856 11.3476 14.3937 11.5759 14.0883 12.0286L14.659 12.3915C14.868 12.0816 15.1534 11.9266 15.5151 11.9266C15.7442 11.9266 15.9653 12.0123 16.1381 12.1672C16.3069 12.314 16.4034 12.5261 16.4034 12.7504V12.9012C16.1542 12.7626 15.8407 12.6892 15.4548 12.6892C15.0047 12.6892 14.6429 12.7952 14.3736 13.0113C14.1043 13.2275 13.9677 13.5129 13.9677 13.8758C13.9596 14.2061 14.1003 14.5201 14.3495 14.7322C14.6027 14.9605 14.9243 15.0747 15.3021 15.0747C15.7483 15.0747 16.102 14.8749 16.3713 14.4753H16.3994V14.9605H17.0184V12.8034C17.0184 12.3507 16.8817 11.9919 16.6044 11.735ZM14.8482 14.3162C14.7155 14.2184 14.6351 14.0593 14.6351 13.8881C14.6351 13.6964 14.7235 13.5374 14.8964 13.411C15.0733 13.2846 15.2944 13.2193 15.5557 13.2193C15.9175 13.2152 16.1989 13.2968 16.3999 13.4599C16.3999 13.7372 16.2913 13.9778 16.0783 14.1817C15.8853 14.3774 15.624 14.4875 15.3507 14.4875C15.1698 14.4916 14.9929 14.4304 14.8482 14.3162ZM18.4089 16.4978L20.5713 11.4618H19.8679L18.8671 13.9737H18.8551L17.8301 11.4618H17.1267L18.5456 14.7362L17.7417 16.4978H18.4089Z",
  fill: "#3C4043"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.10062 12.4411C9.10062 12.2412 9.08454 12.0414 9.05238 11.8457H6.32324V12.9753H7.88677C7.82246 13.3382 7.61346 13.6644 7.30798 13.8683V14.6023H8.24047C8.78711 14.0926 9.10062 13.3382 9.10062 12.4411Z",
  fill: "#4285F4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.32346 15.3118C7.10321 15.3118 7.76239 15.0508 8.24069 14.6022L7.3082 13.8682C7.04694 14.0476 6.71334 14.1496 6.32346 14.1496C5.56782 14.1496 4.92874 13.6317 4.69964 12.9385H3.73901V13.6969C4.22937 14.6878 5.23019 15.3118 6.32346 15.3118Z",
  fill: "#34A853"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.69979 12.9385C4.57919 12.5755 4.57919 12.18 4.69979 11.813V11.0586H3.73901C3.32495 11.8864 3.32495 12.8651 3.73901 13.6928L4.69979 12.9385Z",
  fill: "#FBBC04"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.32346 10.6018C6.73745 10.5936 7.13537 10.7527 7.4328 11.0422L8.26079 10.2022C7.73425 9.70469 7.04292 9.43148 6.32346 9.43963C5.23019 9.43963 4.22938 10.0676 3.73901 11.0585L4.69964 11.817C4.92874 11.1197 5.56782 10.6018 6.32346 10.6018Z",
  fill: "#EA4335"
});

function SvgGooglepay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglepay);
export default __webpack_public_path__ + "static/media/googlepay.9b6a7daaebf95420a8467e8a4aa2431e.svg";
export { ForwardRef as ReactComponent };